import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faUsers } from '@fortawesome/free-solid-svg-icons';

const RecordCountCard = ({ currentCount, totalCount }) => {
  return (
    <div className="record-count-wrapper">
      <div className="record-count-card">
        <div className="card-content">
          <div className="text-section">
            <span className="label">STUDENT RECORDS COUNT</span>
            <h2 className="value">
              Viewing {currentCount} of {totalCount} records
            </h2>
          </div>
          <div className="icon-section">
            <FontAwesomeIcon icon={faUsers} />
          </div>
        </div>
      </div>
    </div>
  );
};

export default RecordCountCard;